export default "__VITE_ASSET__f12f327a__"